// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { floppyDiskStarArrowRight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-floppy-disk-star-arrow-right': IconFloppyDiskStarArrowRight;
    }
}

/**
 * The icon component for the 'floppyDiskStarArrowRight' icon
 */
export class IconFloppyDiskStarArrowRight extends Icon {
    public constructor() {
        super(floppyDiskStarArrowRight16X16);
    }
}

registerIcon('icon-floppy-disk-star-arrow-right', IconFloppyDiskStarArrowRight);
export const iconFloppyDiskStarArrowRightTag = 'nimble-icon-floppy-disk-star-arrow-right';
